import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';

function Sidebar() {
  const { role } = useAuth();
  const { t } = useTranslation('common');
  const isManager = role === 'staff' || role === 'admin';

  const baseLinks = [
    { to: '/', label: t('nav.dashboard') },
    { to: '/expenses', label: t('nav.expenses') },
    { to: '/goals', label: t('nav.goals') },
    { to: '/checklist', label: t('nav.checklist') },
  ];

  if (isManager) return null;

  return (
    <aside className="sidebar">
      <nav>
        {baseLinks.map((link) => (
          <NavLink key={link.to} to={link.to} className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
            {link.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}

export default Sidebar;
